<template>
  <div class="sidebar" :class="{ mobile: isMobile, expanded: isExpandSidebar }">
    <!-- <div class="sidebar-overlay" v-if="showSideBar"></div> -->

    <div class="sidebar__routers">
      <div class="sidebar-brand">
        <!-- <SideBarToggle class="sidebar-toggle" /> -->
        <router-link
          v-show="isExpandSidebar"
          tag="a"
          :to="{ path: '/', query: $route.query }"
          class="navbar-brand"
          >DASH</router-link
        >
        <div
          v-if="!isMobile"
          class="icon-wrapper"
          @click="toggleIsExpandSidebar"
        >
          <fa
            icon="angle-double-left"
            :class="{ 'fa-rotate-180': !isExpandSidebar }"
          ></fa>
        </div>
        <div v-else class="icon-wrapper" @click="toggleIsShowSidebarOnMobile">
          <fa icon="times"></fa>
        </div>
      </div>
      <ul class="sidebar-nav">
        <li class="expand dashboard">
          <div
            class="expand__toggle"
            @click="toggleIsShowRoutingStatusCatalogue"
          >
            <div
              class="icon-wrapper"
              :class="{ active: isRoutingStatusIconActive }"
            >
              <img src="../../assets/RoutingNetwork_White.svg" class="icon" />
            </div>
            <div class="parent-catalogue">
              <span class="nav-label">Routing status</span>
              <fa
                icon="chevron-down"
                :class="{ 'fa-rotate-180': isShowRoutingStatusCatalogue }"
              ></fa>
            </div>
          </div>
          <div
            class="expand__list routing-status"
            :class="{ 'show-list': isShowRoutingStatusCatalogue }"
          >
            <ul>
              <router-link
                class="expand__item"
                tag="li"
                :to="{ path: '/routing-status', query: $route.query }"
                active-class="active"
              >
                <div class="child-catalogue">
                  <span class="nav-label">Dashboard</span>
                </div>
              </router-link>
              <router-link
                class="expand__item"
                tag="li"
                :to="{ path: '/alerts-routing-status', query: $route.query }"
                active-class="active"
              >
                <div class="child-catalogue">
                  <span class="nav-label"> Alerts </span>
                </div>
                <div
                  v-if="firingAlertsAmountOfSelectedAccount > 0"
                  class="badge--warning"
                >
                  {{ firingAlertsAmountOfSelectedAccount }}
                </div>
              </router-link>
            </ul>
          </div>
        </li>
        <li class="expand dashboard">
          <div
            class="expand__toggle"
            @click="toggleIsShowSuspiciousTrafficCatalogue"
          >
            <div
              class="icon-wrapper"
              :class="{ active: isSuspiciousTrafficIconActive }"
            >
              <img src="../../assets/HoneyNet_White.svg" class="icon" />
            </div>
            <div class="parent-catalogue">
              <span class="nav-label">Suspicious traffic</span>
              <fa
                icon="chevron-down"
                :class="{ 'fa-rotate-180': isShowSuspiciousTrafficCatalogue }"
              ></fa>
            </div>
          </div>
          <div
            class="expand__list suspicious-traffic"
            :class="{ 'show-list': isShowSuspiciousTrafficCatalogue }"
          >
            <ul>
              <router-link
                class="expand__item"
                tag="li"
                :to="{ path: '/suspicious-traffic', query: $route.query }"
                active-class="active"
              >
                <div class="child-catalogue">
                  <span class="nav-label">Dashboard</span>
                </div>
              </router-link>
              <router-link
                class="expand__item"
                tag="li"
                :to="{
                  path: '/alerts-suspicious-traffic',
                  query: $route.query
                }"
                active-class="active"
              >
                <div class="child-catalogue">
                  <span class="nav-label">Alerts</span>
                </div>
                <div v-if="isShowFiringAlertsNumber" class="badge--warning">
                  {{ firingAlertsAmountOfSelectedMemberId }}
                </div>
              </router-link>
              <!-- Hide this tab temporarily.-->
              <!-- When restore it, please: 1. restore height of .suspicious-traffic.show-list; 2. restore "Request insights" introduction accordion on Help page -->
              <!-- <router-link
                class="expand__item"
                tag="li"
                :to="{
                  path: '/what-to-do',
                  query: $route.query
                }"
                active-class="active"
              >
                <div class="child-catalogue">
                  <span class="nav-label">Request insights</span>
                </div>
              </router-link> -->
            </ul>
          </div>
        </li>
        <router-link
          tag="li"
          :to="{ path: '/security', query: $route.query }"
          active-class="active"
        >
          <div class="icon-wrapper">
            <fa icon="newspaper"></fa>
          </div>
          <div class="ga__latest-news-btn">
            <span class="nav-label">Latest security news</span>
          </div>
        </router-link>
      </ul>
    </div>
    <div class="sidebar-nav-links">
      <p v-show="isExpandSidebar">Useful links</p>
      <ul>
        <router-link
          tag="li"
          :to="{ path: '/help', query: $route.query }"
          active-class="active"
        >
          <div class="icon-wrapper">
            <fa icon="info"></fa>
          </div>
          <div class="ga__help-btn">
            <span class="nav-label">Help</span>
          </div>
        </router-link>
        <!-- <router-link tag="li" :to="{ path: '/methodology', query: $route.query }" active-class="active">
          <a class="ga__methodology-btn">
            <span class="nav-label">Methodology</span>
          </a>
          </router-link>-->
        <router-link
          tag="li"
          :to="{ path: '/data-source', query: $route.query }"
          active-class="active"
        >
          <div class="icon-wrapper">
            <fa icon="server"></fa>
          </div>
          <div class="ga__acknowledgment-btn">
            <span class="nav-label">Data source</span>
          </div>
        </router-link>
        <router-link
          tag="li"
          :to="{ path: '/disclaimer', query: $route.query }"
          active-class="active"
        >
          <div class="icon-wrapper">
            <fa icon="balance-scale" class="fa-w-16"></fa>
          </div>
          <div class="ga__disclaimer-btn">
            <span class="nav-label">Disclaimer</span>
          </div>
        </router-link>
      </ul>
    </div>
  </div>
  <!-- /#sidebar-wrapper -->
</template>

<script>
import * as vClickOutside from 'v-click-outside';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import mixin from '../../utils/mixin';
import SideBarToggle from './SidebarToggle';
import { mapGetters, mapState } from 'vuex';

export default {
  mixins: [mixin],
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      isShowRoutingStatusCatalogue: true,
      isShowSuspiciousTrafficCatalogue: true
    };
  },
  computed: {
    ...mapGetters('alertsSuspiciousTrafficStore', [
      'firingAlertsAmountOfSelectedMemberId'
    ]),
    ...mapGetters('alertsRoutingStatusStore', [
      'firingAlertsAmountOfSelectedAccount'
    ]),

    isShowFiringAlertsNumber() {
      return this.firingAlertsAmountOfSelectedMemberId > 0;
    },
    isRoutingStatusIconActive() {
      return this.$route.path.indexOf('routing-status') > -1;
    },
    isSuspiciousTrafficIconActive() {
      return (
        this.$route.path.indexOf('suspicious-traffic') > -1 ||
        this.$route.path.indexOf('alerts') === 0
      );
    }
  },
  methods: {
    toggleIsExpandSidebar() {
      if (!this.isExpandSidebar) {
        this.isShowRoutingStatusCatalogue = true;
        this.isShowSuspiciousTrafficCatalogue = true;
      } else {
        this.isShowRoutingStatusCatalogue = false;
        this.isShowSuspiciousTrafficCatalogue = false;
      }

      this.setIsExpandSidebar(!this.isExpandSidebar);
    },

    toggleIsShowSidebarOnMobile() {
      this.$emit('onToggleIsShowSidebarOnMobile');
    },

    toggleIsShowRoutingStatusCatalogue() {
      if (!this.isMobile && !this.isExpandSidebar) {
        this.toggleIsExpandSidebar();
      } else {
        this.isShowRoutingStatusCatalogue = !this.isShowRoutingStatusCatalogue;
      }
    },

    toggleIsShowSuspiciousTrafficCatalogue() {
      if (!this.isMobile && !this.isExpandSidebar) {
        this.toggleIsExpandSidebar();
      } else {
        this.isShowSuspiciousTrafficCatalogue =
          !this.isShowSuspiciousTrafficCatalogue;
      }
    },

    toggleIsShowAlerts() {
      if (!this.isMobile && !this.isExpandSidebar) {
        this.toggleIsExpandSidebar();
      } else {
        this.isShowAlerts = !this.isShowAlerts;
      }
    }
  },
  watch: {
    $route(to, from) {
      if (
        this.isMobile &&
        this.isShowSidebarOnMobile &&
        from &&
        from.path.indexOf('auth') < 0
      ) {
        this.toggleIsShowSidebarOnMobile();
      }
    }
  },
  components: {
    vueCustomScrollbar,
    SideBarToggle
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.sidebar {
  position: fixed;
  top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 300px;
  height: calc(100vh - 40px);
  overflow-y: auto;
  color: $background-white;
  background-color: $text-black;

  .sidebar-brand {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0;
    height: 3.75rem;
    border-bottom: 4px $text-light-blue solid;

    .navbar-brand {
      margin-left: 1rem;
      font-size: 1.5rem;
      width: initial;
      font-weight: 600;

      color: $text-black;
    }

    .icon-wrapper {
      margin-left: 0.5rem;
      width: 3rem;
      height: 3rem;
      line-height: 3rem;
      text-align: center;
      font-size: 1rem;
      color: $text-black;
      cursor: pointer;

      svg {
        transition: transform 0.5s;
      }
    }
  }

  .sidebar-nav-links {
    p {
      padding: 0.5rem 1rem;
      font-weight: 600;
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li,
  .expand__toggle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    margin: 0rem 0;
    cursor: pointer;
    color: $background-white;

    & > div {
      display: inline-block;
      padding: 0;
      margin: 0;
    }

    .icon-wrapper {
      margin: 0 1rem;
      width: 2rem;
      text-align: center;
      color: #fff;
      font-size: 2rem;

      .icon {
        height: 2rem;
        width: 1.5rem;
        padding-bottom: 4px;
        margin-bottom: -4px;
        border-top: 4px solid rgba($color: #000000, $alpha: 0);
        border-bottom: 4px solid rgba($color: #000000, $alpha: 0);
      }

      svg {
        width: 1.5rem;
        padding-bottom: 4px;
        margin-bottom: -4px;
        border-top: 4px solid rgba($color: #000000, $alpha: 0);
        border-bottom: 4px solid rgba($color: #000000, $alpha: 0);
      }

      &.active {
        svg,
        img {
          border-bottom: 4px solid $apnic-blue;
        }
      }
    }

    a {
      text-decoration: none;
    }

    &.active {
      font-weight: 600;

      svg,
      i,
      img {
        border-bottom: 4px solid $apnic-blue;
      }
    }

    span {
      height: 3rem;
      line-height: 3rem;
    }
  }

  li {
    &:hover {
      background-color: #333;
    }
  }

  .expand {
    display: flex;
    flex-direction: column;
    cursor: none;

    &:hover {
      background-color: #1a1a1a;
    }

    &__toggle {
      .parent-catalogue {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 5.5rem);
      }
    }

    &__list {
      display: block;
      overflow: hidden;
      width: 100%;
      height: 0;
      transition: height 0.5s;

      &.routing-status.show-list {
        height: 6rem;
      }

      &.suspicious-traffic.show-list {
        height: 6rem;
      }

      .expand__item {
        padding-left: 4rem;
        position: relative;

        .child-catalogue {
          height: 3rem;
          border-bottom: none;

          svg {
            width: 1.5rem;
            height: 2rem;
            margin-bottom: -12px;
            padding-bottom: 4px;
            border-bottom: 4px solid rgba($color: #000000, $alpha: 0);
          }

          svg.alerts {
            padding-left: 0.15rem;
          }

          & > span {
            padding-left: 0rem;
            padding-bottom: 4px;
            border-bottom: 2px solid rgba($color: #000000, $alpha: 0);
          }
        }

        &.active {
          .child-catalogue {
            & > span {
              border-bottom: 2px solid $apnic-blue;
            }
          }
        }
      }
    }
  }
}

.sidebar.expanded {
  .icon-wrapper {
    margin-right: 0.7rem;
  }
}

.ga__alerts-btn {
  position: relative;
}

svg {
  width: 1rem;
}

.badge--warning {
  position: absolute;
  display: inline-block;
  left: 8rem;
  width: 1.5rem;
  height: 1.5rem;
  line-height: 1.5rem;
  margin-top: 0.7rem;
  border-radius: 50%;
  background-color: $warning-red;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 600;
  text-indent: 0;
  text-align: center;
}

.mobile.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
}
</style>
